<header class="bg-surface/95 backdrop-blur-sm sticky top-0 z-50 shadow-sm">
  <div class="flex justify-between items-center w-full px-margin-mobile h-16 max-w-container-max mx-auto">
    <a routerLink="/" class="flex items-center gap-2" aria-label="Chambia — Inicio">
      <img src="assets/icons/logo-nav.png" alt="Chambia" width="32" height="32" class="w-8 h-8">
      <span class="text-2xl font-extrabold text-primary">Chambia</span>
    </a>

    <nav class="hidden md:flex items-center gap-8 font-medium text-on-surface-variant">
      <a routerLink="/vacantes" routerLinkActive="text-primary" class="hover:text-primary transition-colors">Vacantes</a>
      <a routerLink="/empresas" routerLinkActive="text-primary" class="hover:text-primary transition-colors">Soy empresa</a>
      @if (auth.isLoggedIn) {
        <a routerLink="/mis-aplicaciones" routerLinkActive="text-primary" class="hover:text-primary transition-colors">Mis aplicaciones</a>
        <a routerLink="/vacantes-guardadas" routerLinkActive="text-primary" class="hover:text-primary transition-colors">Vacantes guardadas</a>
      }
    </nav>

    <div class="hidden md:flex items-center gap-3">
      @if (auth.isLoggedIn) {
        <span class="text-sm text-on-surface-variant">
          Hola
        </span>
        <button type="button" class="btn-secondary !px-4 !py-2" (click)="logout()">Cerrar sesión</button>
      } @else {
        <button type="button" class="btn-secondary !px-4 !py-2" (click)="openLogin()">Ingresar</button>
        <a routerLink="/empresas" class="btn-primary !px-4 !py-2">Solicita demo</a>
      }
    </div>

    <button
      type="button"
      class="md:hidden text-on-surface"
      (click)="toggleMobileMenu()"
      [attr.aria-expanded]="mobileMenuOpen()"
      aria-label="Abrir menú"
    >
      <span class="material-symbols-outlined text-3xl">
        {{ mobileMenuOpen() ? 'close' : 'menu' }}
      </span>
    </button>
  </div>

  @if (mobileMenuOpen()) {
    <nav class="md:hidden bg-white border-t border-outline-variant px-margin-mobile py-4 flex flex-col gap-4">
      <a routerLink="/vacantes" (click)="closeMobileMenu()" class="font-medium">Vacantes</a>
      <a routerLink="/empresas" (click)="closeMobileMenu()" class="font-medium">Soy empresa</a>
      @if (auth.isLoggedIn) {
        <a routerLink="/mis-aplicaciones" (click)="closeMobileMenu()" class="font-medium">Mis aplicaciones</a>
        <a routerLink="/vacantes-guardadas" (click)="closeMobileMenu()" class="font-medium">Vacantes guardadas</a>
        <button type="button" class="btn-secondary" (click)="logout(); closeMobileMenu()">Cerrar sesión</button>
      } @else {
        <button type="button" class="btn-secondary" (click)="openLogin(); closeMobileMenu()">Ingresar</button>
      }
    </nav>
  }
</header>

@if (loginModalOpen()) {
  <app-login-modal (closed)="closeLogin()" />
}
